import { Link } from "react-router-dom";
import { money } from "@/lib/api";
import { Star } from "lucide-react";

export default function ProductCard({ product }) {
  const compare = product.compare_at_price && product.compare_at_price > product.base_price;
  return (
    <Link
      to={`/products/${product.handle}`}
      data-testid={`product-card-${product.handle}`}
      className="group block soft-card overflow-hidden"
    >
      <div className="aspect-square overflow-hidden bg-white relative">
        <img
          src={product.images?.[0]}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-500 ease-out group-hover:scale-105"
        />
        {product.badge && (
          <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-white/95 backdrop-blur-md text-[10px] font-bold uppercase tracking-widest text-[#0066FF]">
            {product.badge}
          </span>
        )}
      </div>
      <div className="p-5">
        <div className="flex items-center gap-1 text-[#86868B] text-xs mb-1">
          <Star size={12} fill="#0066FF" stroke="#0066FF" />
          <span>{product.rating?.toFixed?.(1) || product.rating} · {product.review_count} reviews</span>
        </div>
        <h3 className="font-display text-lg font-bold text-[#1D1D1F] mb-2 leading-tight">{product.name}</h3>
        <p className="text-sm text-[#86868B] line-clamp-2 mb-4">{product.short_description}</p>
        <div className="flex items-baseline gap-2">
          <span className="text-lg font-semibold text-[#1D1D1F]">{money(product.base_price)}</span>
          {compare && (
            <span className="text-sm text-[#86868B] line-through">{money(product.compare_at_price)}</span>
          )}
        </div>
      </div>
    </Link>
  );
}
